import { setSessionInfo } from 'actions/index';
import { connect } from 'react-redux';

import JSX from '../GoogleAuth';

const mapDispatchToProps = (dispatch) => ({
    setSessionInfo: (sessionInfo) => dispatch(setSessionInfo(sessionInfo))
});

export default connect(null, mapDispatchToProps)(JSX);
